import { connect } from 'react-redux';
import {} from '../../actions';
// import { bindActionCreators } from 'redux';
import ExchangeMember from './ExchangeMember';

const mapStateToProps = (state) => {
	return {
		exchange: state.exchange,
		collateral: state.collateral,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeMember);
